import React, {
  useLayoutEffect,
  useRef,
  useState,
  FC,
} from 'react';
import { SpheraTooltip } from '@sphera-cloud/component-ui-reactjs';
import _ from 'lodash';

interface TruncateTextProps {
  text: string;
  tooltipText?: string;
  toTruncateTextAlways?: boolean;
  parentClassname?: string;
}

export const TruncateText: FC<TruncateTextProps> = ({
  text,
  toTruncateTextAlways = false,
  tooltipText,
  parentClassname='',
}) => {
  const textRef = useRef<HTMLDivElement | null>(null);
  const [isOverflowed, setIsOverflowed] = useState<boolean>(false);
  const [width, setWidth] = useState<string| undefined>();

  useLayoutEffect(() => {
    const checkOverflow = () => {
      if (textRef.current) {
        const isOverflowed = textRef.current.scrollWidth > textRef.current.clientWidth;
        setIsOverflowed(isOverflowed);
        const parentEl = document.getElementsByClassName(parentClassname)[0];
        if (parentEl?.clientWidth) {
          setWidth(`${parentEl.clientWidth + 10}px`);
        } else {
          setWidth('100%');
        }
      }
    };

    const resizeObserver = new ResizeObserver(checkOverflow);
    const parentEl = document.getElementsByClassName(parentClassname)[0];
    if (parentEl) {
      resizeObserver.observe(parentEl);
    }

    checkOverflow();

    return () => {
      if (parentEl) {
        resizeObserver.unobserve(parentEl);
      }
    };
  }, [parentClassname, text]);

  function shortened(text: string, length = 4) {
    return `${text.substring(0, length)}...${text.substring(text.length - length)}`;
  }

  return (
    <div
      className="truncate-text"
      style={{ float: 'left', maxWidth: !toTruncateTextAlways ? width : '' }}
      title={_.isEmpty(tooltipText) ? text : tooltipText}
    >
      <SpheraTooltip anchor="target" position="bottom">
        <div className="truncate-text__single-line">
          <div className={`truncate-text__text ${isOverflowed && !toTruncateTextAlways ? 'overflowed' : ''}`}
               ref={textRef}
               role="button"
               aria-label=""
               tabIndex={0}
          >
            {toTruncateTextAlways ? shortened(text) : text}
          </div>
        </div>
      </SpheraTooltip>
    </div>
  );
};
